import { Connection } from './connection';
import { Entity } from './entity';

export interface ReadOnlyOneOf<T extends Entity> {
  readonly item: T | null;
}

export class OneOf<T extends Entity> implements ReadOnlyOneOf<T>, Connection {
  public item: T | null;
  public connectionId: string | null = null;

  constructor(item: T | null) {
    this.item = item;
  }
}
